module.exports = __webpack_public_path__ + "img/adventure_thumbnail-600x450.fcaa0c2a.jpg";